__webpack_require__.p = "/wordle_logo_generator/";